(() => {
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const initRotators = (root = document) => {
    $$('[data-mah-product-rotator]', root).forEach((rotator) => {
      if (rotator.dataset.mahV4Ready === 'true') return;
      rotator.dataset.mahV4Ready = 'true';
      const slides = $$('[data-mah-product-slide]', rotator);
      const dots = $$('[data-mah-rotator-dot]', rotator);
      if (slides.length < 2) return;
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let paused = false;
      let timer;
      const toggle = rotator.querySelector('[data-mah-rotator-toggle]');

      const display = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.hidden = false;
          slide.setAttribute('aria-hidden', String(!active));
          $$('a,button,input,select,textarea', slide).forEach((element) => {
            if (active) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', '-1');
          });
        });
        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
          dot.tabIndex = active ? 0 : -1;
        });
      };
      const schedule = () => {
        window.clearTimeout(timer);
        if (!paused && !document.hidden) timer = window.setTimeout(() => { display(current + 1); schedule(); }, 4500);
      };
      rotator.querySelector('[data-mah-rotator-prev]')?.addEventListener('click', () => { display(current - 1); schedule(); });
      rotator.querySelector('[data-mah-rotator-next]')?.addEventListener('click', () => { display(current + 1); schedule(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { display(i); schedule(); }));
      toggle?.addEventListener('click', () => {
        paused = !paused;
        toggle.textContent = paused ? 'Play' : 'Pause';
        toggle.setAttribute('aria-pressed', String(paused));
        schedule();
      });
      document.addEventListener('visibilitychange', schedule);
      display(current);
      schedule();
    });
  };

  const initGalleries = (root = document) => {
    $$('[data-mah-gallery]', root).forEach((gallery) => {
      if (gallery.dataset.mahV4Ready === 'true') return;
      gallery.dataset.mahV4Ready = 'true';
      const panels = $$('[data-mah-gallery-panel]', gallery);
      const thumbs = $$('[data-mah-gallery-thumb]', gallery);
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.mahGalleryThumb || 0);
        panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          panel.classList.toggle('is-active', i === index);
          if (i !== index) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbs.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          item.setAttribute('aria-pressed', String(i === index));
        });
      }));
    });
  };

  const formatMoney = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-MY', { style: 'currency', currency: window.Shopify?.currency?.active || 'MYR' }).format(cents / 100); }
    catch (_) { return `RM${(cents / 100).toFixed(2)}`; }
  };

  const initProductForms = (root = document) => {
    $$('[data-mah-pdp-v4]', root).forEach((section) => {
      if (section.dataset.mahFormReady === 'true') return;
      section.dataset.mahFormReady = 'true';
      const form = section.querySelector('.mah-pdp-v4__form');
      if (!form) return;
      let variants = [];
      try { variants = JSON.parse(section.querySelector('[data-mah-variants]')?.textContent || '[]'); } catch (_) { variants = []; }
      const select = form.querySelector('[data-mah-variant-select]');
      const hiddenId = form.querySelector('[data-mah-variant-id]');
      const price = section.querySelector('[data-mah-product-price]');
      const status = section.querySelector('[data-mah-product-status]');
      const button = form.querySelector('[data-mah-add-button]');
      const label = form.querySelector('[data-mah-add-label]');
      const message = form.querySelector('[data-mah-form-message]');
      const qty = form.querySelector('input[name="quantity"]');

      form.querySelector('[data-mah-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); });
      form.querySelector('[data-mah-qty-plus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) + 1); });

      const updateVariant = () => {
        const id = Number(select?.value || hiddenId?.value || 0);
        const variant = variants.find((item) => Number(item.id) === id);
        if (!variant) return;
        if (price) {
          const save = variant.compare_at_price > variant.price ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
          price.innerHTML = `<strong>${formatMoney(variant.price)}</strong>${variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}${save ? `<em>Save ${save}%</em>` : ''}`;
        }
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (status) {
          status.classList.toggle('is-unavailable', !variant.available);
          let text = variant.available ? 'Available to order' : 'Currently unavailable';
          if (variant.available && variant.inventory_management && variant.inventory_policy !== 'continue' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 30) text = `Only ${variant.inventory_quantity} available`;
          status.innerHTML = `<span class="mah-pdp-v4__status-dot"></span>${text}`;
        }
      };
      select?.addEventListener('change', updateVariant);

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button?.disabled) return;
        button.disabled = true;
        if (label) label.textContent = 'Adding…';
        if (message) message.textContent = '';
        try {
          const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'This item could not be added.');
          if (message) message.innerHTML = `Added to cart. <a href="/cart">View cart</a>`;
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          $$('[data-mah-cart-count]').forEach((counter) => { counter.textContent = cart.item_count; });
        } catch (error) {
          if (message) message.textContent = error.message || 'This item could not be added. Please try again.';
        } finally {
          updateVariant();
        }
      });
      updateVariant();
    });
  };

  const init = (root = document) => { initRotators(root); initGalleries(root); initProductForms(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
